import React from 'react';
import PropTypes from 'prop-types';


/* Simple button requires following props: 
    1) button text,  2) onClickHandler 3)  number of words (to guage size) 4) color 5) alternate style
    Note: alternate style is commented out. Just uncommment if you plan to use an alternative style
*/

export const ShadowButton  = (props) => {
    let buttonstyle = "shadow-button"
    let words    = 1;

    /* construct class name */
    if (props.color) {
        buttonstyle = buttonstyle + '-' + props.color;
    }
    if (props.words) { 
        buttonstyle = buttonstyle + '-' + props.words;
    } 

     /* set type property */
     let type = props.type || "button"

    // if (props.altstyle) { 
    //     buttonstyle = "simple-button-alt";
    // } 


    return  (
      <button onClick={props.onClickHandler} className={buttonstyle} type={type}>
         {props.buttonText}
      </button>
    )
}

ShadowButton.propTypes = {
    buttonText:     PropTypes.string.isRequired,
    onClickHandler: PropTypes.func,
    altstyle:       PropTypes.string,
    color:          PropTypes.string,
    words:          PropTypes.number
};




// WEBPACK FOOTER //
// ./src/components/buttons/ShadowButton.js